<template>
  <span v-if="value">
    {{ value }}
  </span>
</template>

<script>
import { fieldMixin } from '../../mixins/fieldMixin'

export default {
  mixins: [fieldMixin],
  sync: ['value']
}
</script>
